import { PerformanceChart } from '../../../components/core-v2'

type PerformanceProps = {
  timeseries: Record<string, number>
}

export const PerformanceTab = ({ timeseries }: PerformanceProps) => (
  <PerformanceChart
    isError={false}
    isLoading={false}
    metrics={timeseries}
    title="Historical performance"
  />
)
